<template>
  <div class="home">
    <el-tabs
      v-model="toggleName"
      type="card"
    >
      <el-tab-pane
        label="图表"
        name="chart"
      >
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
          >
            <div class="dashboard-stat untreated">
              <div class="visual">
                <i class="el-icon-lollipop" />
              </div>
              <div class="details">
                <div class="number">
                  {{ statisticsData.customerCount }}
                </div>
                <div class="desc">
                  客户总数
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
          >
            <div class="dashboard-stat underway">
              <div class="visual">
                <i class="el-icon-plus" />
              </div>
              <div class="details">
                <div class="number">
                  {{ statisticsData.customerTodayCount }}
                </div>
                <div class="desc">
                  今日新增客户数
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
          >
            <div class="dashboard-stat completed">
              <div class="visual">
                <i class="el-icon-menu" />
              </div>
              <div class="details">
                <div class="number">
                  {{ statisticsData.orderCount }}
                </div>
                <div class="desc">
                  订单总数
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
          >
            <div class="dashboard-stat all">
              <div class="visual">
                <i class="el-icon-edit-outline" />
              </div>
              <div class="details">
                <div class="number">
                  {{ statisticsData.orderTodayCount }}
                </div>
                <div class="desc">
                  今日新增订单数
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="12"
            style="margin-top: 20px"
          >
            客户数据统计（每日）
            <el-divider />
            <div
              id="line-echarts"
              class="tpl-echarts"
            />
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            style="margin-top: 20px"
          >
            订单数据统计（每月）
            <el-divider />
            <div
              id="line-echarts-order"
              class="tpl-echarts"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane
        label="客户管理"
        name="customer"
      >
        <div class="common-search-content">
          <el-form
            :inline="true"
            :model="formSearch"
            class="demo-form-inline"
            label-width="80px"
            size="small"
          >
            <el-form-item label="客户名称">
              <el-input
                v-model="formSearch.name"
                placeholder="请输入客户名称"
              />
            </el-form-item>
            <el-form-item label="负责人">
              <el-input
                v-model="formSearch.manager"
                placeholder="请输入负责人"
              />
            </el-form-item>
            <el-form-item label="手机">
              <el-input
                v-model="formSearch.mobile"
                placeholder="请输入手机号码"
              />
            </el-form-item>
            <el-form-item label="电话">
              <el-input
                v-model="formSearch.phone_num"
                placeholder="请输入电话号码"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="search"
              >
                搜 索
              </el-button>
              <el-button
                plain
                @click="resetSearch"
              >
                清空
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="btngroup">
          <div class="fright">
            <el-button
              type="primary"
              size="small"
              @click="addCUsHandle"
            >
              添加客户
            </el-button>
          </div>
        </div>

        <el-table
          :data="dataTable"
          header-row-class-name="headerbg"
        >
          <el-table-column
            label="客户"
            prop="name"
          />
          <el-table-column
            label="负责人"
            prop="manager"
          />
          <el-table-column
            label="会员级别"
            prop="vip_level_name"
          />
          <el-table-column
            label="手机号"
            prop="mobile"
          />
          <el-table-column
            label="电话号"
            prop="phone_num"
          />
          <el-table-column
            label="唯一ID"
            prop="only_id"
          />
          <el-table-column>
            <template slot-scope="scope">
              <el-button
                v-if="parseInt(scope.row.type)===2"
                type="primary"
                plain
                size="small"
                @click="addManagerHandle(scope.row)"
              >
                管理员
                {{ scope.row.ii }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="margintb20">
          <el-pagination
            background
            :hide-on-sigle-page="true"
            :page-sizes="[10, 25, 50, 100]"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handlePageSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="添加新客户"
      :visible.sync="dialogCustomerVisible"
    >
      <el-form
        :model="formCustomer"
        label-width="80px"
        size="small"
      >
        <el-form-item
          label="客户类型"
          required
        >
          <el-radio
            v-model="formCustomer.type"
            label="21"
          >
            内部报修版
          </el-radio>
          <el-radio
            v-model="formCustomer.type"
            label="31"
          >
            专业维修版
          </el-radio>
        </el-form-item>
        <el-form-item
          label="公司"
          required
        >
          <el-input
            v-model="formCustomer.company"
            placeholder="请输入公司名称"
          />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input
            v-model="formCustomer.manager"
            placeholder="请输入联系人"
          />
        </el-form-item>
        <el-form-item label="手机">
          <el-input
            v-model="formCustomer.mobile"
            placeholder="请输入手机"
          />
        </el-form-item>
        <el-form-item label="电话">
          <el-input
            v-model="formCustomer.telephone"
            placeholder="请输入电话"
          />
        </el-form-item>
        <el-form-item label="所在地区">
          <el-input
            v-model="formCustomer.area"
            readonly
            placeholder="请选择所在地区"
            @focus="areaCilck"
          />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input
            v-model="formCustomer.address"
            type="textarea"
            placeholder="请输入详细地址"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          size="small"
          @click="addCusConfirm"
        >添加</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="管理员"
      :visible.sync="dialogManagerVisible"
    >
      <el-form
        :model="formManager"
        label-width="100px"
        size="small"
      >
        <el-form-item
          v-if="formManager.account"
          label="账号"
          required
        >
          {{ formManager.account }}
        </el-form-item>
        <el-form-item
          :label="formManager.account?'手机':'手机(账号)'"
          required
        >
          <el-input
            v-model="formManager.mobile"
            placeholder="请输入手机"
          />
        </el-form-item>
        <el-form-item
          v-if="!formManager.account"
          label="密码"
          required
        >
          <el-input
            v-model="formManager.pwd"
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item
          label="姓名"
          required
        >
          <el-input
            v-model="formManager.name"
            placeholder="请输入详细地址"
          />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input
            v-model="formManager.email"
            type="email"
            placeholder="请输入邮箱"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          size="small"
          @click="addManagerConfirm"
        >{{ formManager.account?'确定':'添加' }}</el-button>
      </span>
    </el-dialog>
    <PickerAddress
      v-if="showAddressDialog"
      :dialog-address-visible="showAddressDialog"
      @positionPicker="positionPicker"
      @closeAddress="closeAddress"
    />
  </div>
</template>

<script>
import {

} from '@/api/home';
import { UserModule } from '@/store/modules/user';
import { getAgentOrderCount, getAgentMonthCount, getAgentCustomerEveryDayCount, getAgentCustomerCount, getAgentCustomerList, addCUs, editorManager, addManager } from '@/api/agent';
import PickerAddress from '@/components/PickAddressInMap/index.vue';
var echarts = require('echarts');

export default {
  name: 'Agenthome',
  components: { PickerAddress },
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      toggleName: 'chart',
      radioCus: '1',
      // 折线图
      majorData: {
        newCount: [],
        dayName: [],
        monthName: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
        orderCount: []
      },
      // 统计
      statisticsData: {
        customerCount: 0,
        customerTodayCount: 0,
        orderCount: 0,
        orderTodayCount: 0
      },

      formSearch: {
        name: '',
        manager: '',
        mobile: '',
        phone_num: ''
      },
      dataTable: [],

      dialogCustomerVisible: false,
      showAddressDialog: false,
      formCustomer: {
        type: '',
        company: '',
        manager: '',
        mobile: '',
        telephone: '',
        area: '',
        address: '',
        provinceName: '',
        province: '',
        cityName: '',
        city: '',
        districtName: '',
        district: '',
        latitude: '',
        longitude: ''
      },

      dialogManagerVisible: false,
      formManager: {
        customer_company_id: '',
        account: '',
        pwd: '',
        mobile: '',
        name: '',
        email: ''
      }
    };
  },

  computed: {
    classOption: function() {
      return {
        step: 0.5,
        limitMoveNum: 10
      };
    },
    classOptionTable: function() {
      return {
        step: 0.5,
        limitMoveNum: 5
      };
    }
  },

  mounted() {
    // 初始化
  },

  created() {
    this.getChartsData();
    this.getAgentCustomerList();
  },
  methods: {
    getChartsData() {
      let pamars = {};
      pamars.user_id = UserModule.getUserId;
      pamars.code = UserModule.getUserInfo.agent_code;
      getAgentOrderCount(pamars).then(res => {
        this.statisticsData.orderCount = res.data.order;
        this.statisticsData.orderTodayCount = res.data.orderToday;
      });
      getAgentCustomerCount(pamars).then(res => {
        this.statisticsData.customerCount = res.data.customer;
        this.statisticsData.customerTodayCount = res.data.customerToday;
      });
      getAgentCustomerEveryDayCount(pamars).then(res => {
        this.majorData.dayName = res.data.day;
        this.majorData.newCount = res.data.count;
        this.echartsDataLine();
      });

      getAgentMonthCount(pamars).then(res => {
        this.majorData.orderCount = res.data;
        this.echartsDataOrder();
      });
    },
    search() {
      this.pagination.currentPage = 1;
      this.getAgentCustomerList();
    },
    resetSearch() {
      this.formSearch = {
        name: '',
        manager: '',
        mobile: '',
        phone_num: ''
      };
      this.pagination.currentPage = 1;
      this.getAgentCustomerList();
    },

    handleCurrentChange(size) {
      this.pagination.currentPage = size;
      this.getAgentCustomerList();
    },

    handlePageSizeChange(size) {
      this.pagination.pageSize = size;
      this.getAgentCustomerList();
    },

    getAgentCustomerList() {
      let pamars = {};
      pamars.user_id = UserModule.getUserId;
      pamars.code = UserModule.getUserInfo.agent_code;
      pamars.size = this.pagination.pageSize;
      pamars.page = this.pagination.currentPage;
      pamars.name = this.formSearch.name;
      pamars.manager = this.formSearch.manager;
      pamars.mobile = this.formSearch.mobile;
      pamars.phone_num = this.formSearch.phone_num;
      getAgentCustomerList(pamars).then(res => {
        if (res.data) {
          this.pagination.total = res.data.count;
          this.dataTable = res.data.list;
        } else {
          this.pagination.total = 0;
          this.dataTable = [];
        }
      }).catch(() => {
        this.pagination.total = 0;
        this.dataTable = [];
      });
    },
    areaCilck() {
      this.showAddressDialog = true;
    },
    // 地图dialog 保存 回调
    positionPicker(address) {
      if (address) {
        this.formCustomer.provinceName = address.province_name;
        this.formCustomer.province = address.province;
        this.formCustomer.cityName = address.city_name;
        this.formCustomer.city = address.city;
        this.formCustomer.districtName = address.district_name;
        this.formCustomer.district = address.district;
        this.formCustomer.latitude = address.latitude;
        this.formCustomer.longitude = address.longitude;
        this.formCustomer.area = address.province_name + '  ' + address.city_name + '  ' + address.district_name;
        this.formCustomer.address = address.address;
      }
    },
    // 地图dialog 关闭
    closeAddress(close) {
      this.showAddressDialog = close;
    },
    addCUsHandle() {
      this.dialogCustomerVisible = true;
      this.formCustomer = {
        type: '',
        company: '',
        manager: '',
        mobile: '',
        telephone: '',
        area: '',
        address: '',
        provinceName: '',
        province: '',
        cityName: '',
        city: '',
        districtName: '',
        district: '',
        latitude: '',
        longitude: ''
      };
    },
    addCusConfirm() {
      if (!this.formCustomer.type) {
        this.showErrorMsg('请选择客户类型');
        return;
      }
      if (!this.formCustomer.company) {
        this.showErrorMsg('请输入公司名称');
        return;
      }
      let pamars = {
        user_id: UserModule.getUserId,
        company_id: UserModule.getCompanyId,
        code: UserModule.getUserInfo.agent_code,
        name: this.formCustomer.company,
        manager: this.formCustomer.manager,
        mobile: this.formCustomer.mobile,
        phone_num: this.formCustomer.telephone,
        province: this.formCustomer.province,
        province_name: this.formCustomer.provinceName,
        city: this.formCustomer.city,
        city_name: this.formCustomer.cityName,
        district: this.formCustomer.district,
        district_name: this.formCustomer.districtName,
        latitude: this.formCustomer.latitude,
        longitude: this.formCustomer.longitude,
        address: this.formCustomer.address,
        vip_level: this.formCustomer.type

      };
      addCUs(pamars).then(res => {
        this.showSecussMsg(res.msg);
        this.dialogCustomerVisible = false;
        this.getAgentCustomerList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    },
    addManagerHandle(val) {
      if (val.user && val.account && val.account.id) {
        this.formManager = val.user;
        this.formManager.account = val.account.account;
        this.formManager.customer_company_id = val.id;
      } else {
        this.formManager = {
          customer_company_id: val.id,
          account: '',
          pwd: '',
          mobile: '',
          name: '',
          email: ''
        };
      }
      this.dialogManagerVisible = true;
    },
    addManagerConfirm() {
      let pamars = {
        user_id: UserModule.getUserId,
        company_id: UserModule.getCompanyId,
        code: UserModule.getUserInfo.agent_code,
        name: this.formManager.name,
        mobile: this.formManager.mobile,
        email: this.formManager.email,
        customer_company_id: this.formManager.customer_company_id

      };
      if (this.formManager.account) {
        editorManager(pamars).then(res => {
          this.showSecussMsg(res.msg);
          this.dialogManagerVisible = false;
          this.getAgentCustomerList();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      } else {
        pamars.password = this.formManager.pwd;
        addManager(pamars).then(res => {
          this.dialogManagerVisible = false;
          this.showSecussMsg(res.msg);
          this.getAgentCustomerList();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      }
    },
    showErrorMsg(msg) {
      this.$notify({
        title: '提示',
        message: msg,
        offset: 100,
        type: 'error'
      });
    },
    showSecussMsg(msg) {
      this.$notify({
        title: '提示',
        message: msg,
        offset: 100,
        type: 'success'
      });
    },

    // 导出客户
    handleExportCus() {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.user_id = UserModule.getUserId;
      pamars.company_name = UserModule.getCompanyName;
      pamars.user_name = UserModule.getUserName;
      pamars.type = this.radioCus;
      pamars.sort_field = 'allOrderCount';
      pamars.sort_rule = 1;
      exportCustomer(pamars)
        .then((res) => {
          this.$confirm('跳转', '跳转', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: '/ExportTask',
                query: {}
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    },

    // 维修首页 折线图 初始化
    echartsDataLine() {
      let myChartsta = echarts.init(document.getElementById('line-echarts'));

      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // orient: 'vertical',
          // x: 'right',
          data: [
            '新增客户数'
          ]
        },
        toolbox: {
          show: true,
          top: 'bottom',
          feature: {
            dataView: {
              readOnly: false,
              show: true,
              title: '',
              lang: ['数据视图', '关闭', '刷新']
            },
            magicType: {
              title: '',
              type: ['line', 'bar']
            },
            restore: {},
            saveAsImage: {
              title: ''
            }
          },
          iconStyle: {
            borderColor: '#555'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.majorData.dayName
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '新增客户数',
            type: 'line',
            lineStyle: {
              color: '#69a3fb',
              width: 1,
              type: 'solid'
            },
            data: this.majorData.newCount
          }
        ],
        color: [
          '#69a3fb'
        ]
      };

      myChartsta.setOption(option);
    },

    echartsDataOrder() {
      let myChartsta = echarts.init(document.getElementById('line-echarts-order'));

      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // orient: 'vertical',
          // x: 'right',
          data: [
            '每月订单数'
          ]
        },
        toolbox: {
          show: true,
          top: 'bottom',
          feature: {
            dataView: {
              readOnly: false,
              show: true,
              title: '',
              lang: ['数据视图', '关闭', '刷新']
            },
            magicType: {
              title: '',
              type: ['line', 'bar']
            },
            restore: {},
            saveAsImage: {
              title: ''
            }
          },
          iconStyle: {
            borderColor: '#555'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.majorData.monthName
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '每月订单数',
            type: 'line',
            lineStyle: {
              color: '#2ac99c',
              width: 1,
              type: 'solid'
            },
            data: this.majorData.orderCount
          }
        ],
        color: [
          '#2ac99c'
        ]
      };

      myChartsta.setOption(option);
    }

  }
};
</script>

<style lang="css">
.text-ellipsis {
  height: 2em;
  overflow: hidden;
}
.scroll_bg {
  width: 100%;
  height: 450px;
  overflow: hidden;
  position: relative;
  border: solid 1px #f5f5f5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 0 10px;
  margin: 10px 0 20px;
}
.scroll_bg ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.scroll_bg li {
  width: 100%;
  padding: 14px 0;
  min-height: 45px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #f5f5f5;
  white-space: nowrap;
  text-overflow: clip;
}

.scroll_bg li .title {
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.countTime {
  letter-spacing: 1px;
  font-size: 12px;
  margin: 10px;
  color: #666;
}
</style>
